import { IAppInfo } from "../../../entities/src/appInfo";
import { Modelable } from "../../../entities/src/modelable";

export class AppInfo implements Modelable<IAppInfo> {
    constructor(public data: IAppInfo) {}
}
